export const figure71 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: [ '#e2f0d9', '#a9d18e' ],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "África septentrional", "Asia meridional (1)", "Asia occidental", "África subsahariana (4)", "Australia y Nueva Zelandia", "Oceanía", "América septentrional (2)", "Europa (3)", "Asia sudoriental (5)", "América Latina y el Caribe (6)", "Asia central", "Oceanía (excluidas Australia y Nueva Zelandia)", "Asia oriental (7)", "", "Mundo" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value:.0f}',
style: {
	 fontWeight: 'normal',
	 color: '#999999',
	 fontSize: '12px'
 },
},
max: 30,
min: 0,
tickInterval: 5,
gridLineWidth: 2,
title: {
	text: '',
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [3.26, 4.49, 4.68, 6.7, 7.2, 8.06, 9.71, 11.05, 13.52, 15.67, 20.22, 22.9, 24.78, null, 11.27],
},
{
name: '2019',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [4.57, 10.41, 11.73, 14.63, 8.03, 8.65, 11.72, 12.84, 17.64, 21.89, 20.32, 19.6, 26.32, null, 15.54],
},
]
}